import 'webrtc-adapter'

export default async function (element) {
  const Quagga = (await import('quagga')).default

  const prom = new Promise(async (resolve) => {
    const opts = {
      inputStream: {
        type: 'LiveStream',
        constraints: {
          facingMode: 'environment',
          width: element.width(),
          height: element.height(),
        },
        target: element.get(0),
      },
      locator: {
        patchSize: 'medium',
        halfSample: true,
      },
      numOfWorkers: 2,
      frequency: 10,
      decoder: {
        readers: [{ format: 'code_128_reader', config: {} }],
      },
      // debug: console.log,
      locate: true,
    }

    console.log({ opts })

    Quagga.init(opts, (err) => {
      if (err) {
        console.log({ err })
      } else {
        console.log('starting')
        Quagga.start()
      }
    })

    const processed = (result) => {
      const drawingCtx = Quagga.canvas.ctx.overlay
      const drawingCanvas = Quagga.canvas.dom.overlay

      if (!result) return

      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute('width')),
          parseInt(drawingCanvas.getAttribute('height'))
        )

        result.boxes
          .filter((box) => box !== result.box)
          .forEach((box) => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: 'green',
              lineWidth: 2,
            })
          })
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: '#00F',
          lineWidth: 2,
        })
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: 'x', y: 'y' },
          drawingCtx,
          { color: 'red', lineWidth: 3 }
        )
      }
    }

    const detected = (result) => {
      const code = result.codeResult.code
      Quagga.offProcessed(processed)
      Quagga.offDetected(detected)
      element.empty()
      cancel()
      resolve(code)
    }

    Quagga.onProcessed(processed)
    Quagga.onDetected(detected)
  })

  var cancel = () => Quagga.stop()
  prom.cancel = cancel
  return prom
}
